import { render, staticRenderFns } from "./AboutTheCompany.vue?vue&type=template&id=7ff710fc&scoped=true"
import script from "./AboutTheCompany.vue?vue&type=script&lang=js"
export * from "./AboutTheCompany.vue?vue&type=script&lang=js"
import style0 from "./AboutTheCompany.vue?vue&type=style&index=0&id=7ff710fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff710fc",
  null
  
)

export default component.exports